export default __webpack_public_path__ + "static/media/caen7.ba101365.jpg";